/**
 * Mounted by `header_filters.es6.jsx`. Calls `handler(syntheticEvent, { id })`
 * to match the existing `handleFilter` contract in
 * `agent_trends.es6.jsx` / `team_trends.es6.jsx`, which still parses the
 * employee id from a `typeahead:select`-shaped payload.
 */
import { useMemo } from 'react';
import { Select } from '@m/alchemy-ui/Select';
import { AlchemyProvider } from '@m/alchemy-ui/AlchemyProvider';

const TITLE_STYLE = { margin: '15px 0', fontSize: '16px' };

const AgentFilter = ({ handler, data, selected }) => {
  const options = useMemo(
    () =>
      Object.entries(data).map(([id, { text, team, deactivated }]) => {
        const label = deactivated ? `${text} (deactivated)` : text;
        return {
          value: id,
          label: (
            <span data-notranslate>
              <strong>{label}</strong>
            </span>
          ),
          description: team ? <span data-notranslate>{`Team - ${team}`}</span> : undefined,
          labelString: team ? `${label} ${team}` : label,
          doNotTranslate: true,
        };
      }),
    [data]
  );

  const value = selected?.value != null ? String(selected.value) : undefined;

  const handleChange = option => {
    if (!option) return;
    handler({ target: { id: 'employee_id', name: 'employee_id' } }, { id: option.value });
  };

  return (
    <div className="col-md-4">
      <h4 style={TITLE_STYLE}>Team member name</h4>
      <AlchemyProvider>
        <Select
          id="employee_id"
          isSearchable
          isFullWidth
          options={options}
          value={value}
          onChange={handleChange}
          placeholder={selected?.filter_label}
        />
      </AlchemyProvider>
    </div>
  );
};

export default AgentFilter;
